/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\DragGalery\Box.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Friday June 16th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 10th November 2023 08:20:15
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Styles from "Content/DragGalery/DragGalery.module.css";
import { RxCrossCircled } from "react-icons/rx";

type BoxProps = {
    boxNumber: string;
    handleDrag: any;
    handleDrop: any;
    goFirst: any;
    PictureURL: string;
    index: number;
    toDelete?: boolean;
    handleDelete?: Function;
    editable?: boolean;
};

function Box(props:BoxProps) {
    const handleDelete = () => {
        if (!props.toDelete && props.handleDelete)
            props.handleDelete(props.boxNumber);
    };

    return (
        <div draggable={props.editable !== false} className={`${Styles.dragPicture} ${!props.editable ? Styles.letsDrag : ""} ${props.toDelete ? Styles.toDelete : ''}`} id={props.boxNumber} onDoubleClick={props.editable !== false ? props.goFirst : () => {}} onDragOver={(ev) => ev.preventDefault()} onDragStart={props.editable !== false ? props.handleDrag : () => {}} onDrop={props.editable !== false ? props.handleDrop : () => {}} >
            {
                !props.toDelete && props.handleDelete && props.editable !== false ?
                    <RxCrossCircled className={`${Styles.close}`} height={"2rem"} width={"2rem"} onClick={() => {handleDelete()}}/>
                : null
            }
            <img className={`${Styles.myPicture}`} src={props.PictureURL} alt={props.PictureURL} />
        </div>
    );
};

export default Box;
